import * as React from "react";
import * as moment from "moment";
import { observer } from "mobx-react";
import { AppStore } from "../../stores/AppStore";
import { observable } from "mobx";
import { Alert, Alignment, Button, Classes, Dialog, FormGroup, H5, Popover, Tab, Tabs, Tag } from "@blueprintjs/core";
import { MDBBtn, MDBCol, MDBRow } from "mdbreact";
import { IEmpresa, newEmpresa } from "../../model";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import { Pager } from "../utils/Pager";
import { toast } from "react-toastify";
import { EmpresaSelect, filterEmpresa, renderEmpresa } from "../empresa/EmpresaSelect";
import { EmpresaStore } from "../../stores/empresa/EmpresaStore";
import { formatCnpj, sortBy } from "../../utils";
import MensagensDecPage from "./MensagensDecPage";
import { DecSefaStore } from "../../stores/dec_sefa/DecSefaStore";
import { getTag } from "../utils/getStatus";
import LoadingModal from "../loading/LoadingModal";

@observer
export default class DecPage extends React.Component<{}, {}> {

    obs = observable({
        tasks_page: 1 as number,
        selectEmpresa: newEmpresa() as IEmpresa,
        selectEmpresaSo: newEmpresa() as IEmpresa,
        erros: [] as any,
        view_erros: false as boolean,
    })

    constructor(props: any) {
        super(props);
    }

    async componentDidMount() {
        if (DecSefaStore.obs.mensagens_pendentes.length > 0) {
            DecSefaStore.obs.open_empresas_mensagens = true
        }

        DecSefaStore.obs.mensagens_decsefa = []
        DecSefaStore.obs.mensagens_length = 0

        DecSefaStore.obs.tasks_decsefa = []
        DecSefaStore.obs.tasks_length = 0
        this.obs.tasks_page = 1

    }

    handleBuscaTarefasPaged = async (page: number) => {
        this.obs.tasks_page = page
        DecSefaStore.obs.loading_tasks = true
        DecSefaStore.handleTasksPaged(page, this.obs.selectEmpresa.cnpj);
    };

    handleBuscaTarefas = async (empresa) => {
        this.obs.selectEmpresa = empresa
        DecSefaStore.obs.loading_tasks = true
        DecSefaStore.handleTasksPaged(1, this.obs.selectEmpresa.cnpj);
    };

    onCloseErros() {
        this.obs.view_erros = false
        this.obs.erros = []
    }

    async handleChangeTab(tabId: string) {
        DecSefaStore.obs.selectedTab = tabId
    }

    handleAtualizaTarefasPaged = async () => {
        if (this.obs.selectEmpresa.cnpj == "") {
            toast.warning('Selecione uma empresa!', {});
            return;
        }
        DecSefaStore.obs.loading_tasks = true
        await DecSefaStore.handleTasksPaged(this.obs.tasks_page, this.obs.selectEmpresa.cnpj);
    };

    async handleCreateTask() {

        if (this.obs.selectEmpresaSo.cnpj == "") {
            toast.warning('Selecione uma empresa.', {});
            return
        }

        DecSefaStore.obs.programar_dec = false

        let res = await DecSefaStore.create_task(this.obs.selectEmpresaSo, true)

        if (res) {

            await DecSefaStore.handleTasksPaged(this.obs.tasks_page, this.obs.selectEmpresa.cnpj);

        }

    }

    handleClose = async () => {
        DecSefaStore.obs.programar_dec = false
        this.obs.selectEmpresa = newEmpresa();
    };

    async handleDeleteDec(row) {

        let res = await DecSefaStore.delete_task(row.id, false)

        if (res) {

            await DecSefaStore.handleTasksPaged(this.obs.tasks_page, this.obs.selectEmpresa.cnpj);

        }

    }

    async handleNaoAceita() {
        AppStore.setLocation("/dashboard")
    }

    async handleAceita() {

        let ret = await DecSefaStore.handleAceitaTermos()

        if (ret) {

            AppStore.obs1.usuario.termos_dec = true

        }

    }

    formatterOrigem = (cell, row) => {

      switch (row.automatica) {
        case true:
          return <span className="new-tag-nav-new">Automático</span>
        default:
          return <span className="new-tag-nav">Manual</span>
      }

    }

    render() {

        if (AppStore.obs1.usuario.termos_dec) {

            return (this.renderNormal())
        }

        return (<>

            <div style={{
                padding: "1.5cm",
                overflow: "auto",
                marginTop: "-80px",
            }}>

                <div style={{ textAlign: "center", marginBottom: 15, fontSize: 14 }}>
                    <b>Termo de Responsabilidade para Leitura Automática de Domicílios Eletrônicos do Contribuinte</b>
                </div>

                <div style={{ textAlign: "justify", overflow: "auto", height: 450, padding: 15, border: "1px solid #000", borderRadius: 10, fontSize: 12 }}>
                    <b>1. Introdução</b>
                    <p>O presente Termo de Responsabilidade tem como objetivo estabelecer as responsabilidades e obrigações da empresa contratante do Sistema FIPO e da empresa desenvolvedora do sistema ("FIPO") em relação à leitura automática dos domicílios eletrônicos do Contribuinte ("DEC") dos contribuintes na Secretaria de Estado da Fazenda ("SEFA").</p>

                    <b>2. Definições</b>
                    <ul>
                        <li><strong>Contratante:</strong> Empresa que contratou o Sistema FIPO para automatizar a gestão de suas obrigações fiscais.</li>
                        <li><strong>FIPO:</strong> Empresa desenvolvedora do Sistema FIPO, responsável pela leitura automática dos DEC dos contribuintes na SEFA.</li>
                        <li><strong>Sistema FIPO:</strong> Software desenvolvido pela FIPO para automatizar a gestão de obrigações fiscais, incluindo a leitura automática dos DEC dos contribuintes na SEFA.</li>
                        <li><strong>DEC:</strong> Endereço eletrônico cadastrado pelo contribuinte na SEFA para recebimento de intimações, notificações e outros atos administrativos.</li>
                    </ul>

                    <p><a href="https://app.sefa.pa.gov.br/pservicos/autenticacao?servico=aHR0cHM6Ly9hcHAuc2VmYS5wYS5nb3YuYnIvZGVjLyMv" target="_black">https://app.sefa.pa.gov.br/pservicos/autenticacao?servico=aHR0cHM6Ly9hcHAuc2VmYS5wYS5nb3YuYnIvZGVjLyMv</a></p>

                    <b>3. Leitura Automática dos DEC</b>
                    <p>O Sistema FIPO está autorizado a ler automaticamente os DEC dos contribuintes na SEFA, em nome da Contratante.</p>

                    <b>4. Responsabilidades da Contratante</b>
                    <ul>
                        <li>A Contratante é a única responsável por garantir que o Sistema FIPO esteja configurado corretamente para ler os DEC.</li>
                        <li>A Contratante é responsável por verificar a autenticidade dos DEC antes de autorizar sua leitura pelo Sistema FIPO.</li>
                        <li>A Contratante é responsável por manter seus dados cadastrais atualizados na SEFA.</li>
                        <li>A Contratante é responsável por qualquer erro ou omissão na leitura dos DEC pelo Sistema FIPO.</li>
                    </ul>

                    <b>5. Responsabilidades da FIPO</b>
                    <ul>
                        <li>Disponibilizar a funcionalidade de leitura automática dos DEC no Sistema FIPO.</li>
                        <li>Manter a segurança da informação dos DEC.</li>
                        <li>Notificar a Contratante em caso de qualquer problema com a leitura dos DEC pelo Sistema FIPO.</li>
                    </ul>

                    <b>6. Cancelamento da Autorização</b>
                    <p>A Contratante poderá cancelar a autorização para leitura automática dos DEC pelo Sistema FIPO a qualquer momento.</p>

                    <b>7. Disposições Gerais</b>
                    <ul>
                        <li>O presente Termo de Responsabilidade é parte integrante do contrato de adesão ao Sistema FIPO.</li>
                        <li>A FIPO poderá alterar este Termo a qualquer tempo, mediante comunicação à Contratante.</li>
                    </ul>

                    <b>8. Aceite</b>
                    <p>Ao utilizar o Sistema FIPO para leitura automática dos DEC, a Contratante declara ter lido e concordado com os termos do presente Termo de Responsabilidade.</p>
                </div>

                <div style={{ textAlign: "center", marginTop: 20 }}>
                    <MDBBtn
                        className="btnDefault btn-usuarios-empresas"
                        onClick={() => this.handleAceita()}
                    >
                        Aceito
                    </MDBBtn>

                </div>

            </div>
        </>)

    }

    renderNormal() {
        AppStore.setTitle("Domicílio Eletrônico do Contribuinte (SEFA)");

        function statusFormatter(cell, row) {
        
          return getTag(row.status, row.tipo);
        
        }

        function dateFormatter(cell, row) {
            return moment(cell).format("DD/MM/YYYY") + " ás " + moment(cell).format("HH:mm");
        };

        function tipoFormatter(cell, row) {
          
          if(!cell) return ""

          return cell.toUpperCase()

        };

        function msgFormatter(cell, row) {
          
          if(!cell) return ""
          // "Proxima execução no dia seguinte entre 00:00 e 23:59 horas."

          return cell

        };

        let empresaText = this.obs.selectEmpresa.cnpj != ""
            ? `${this.obs.selectEmpresa.razao_social.substring(0, 38)}... (${formatCnpj(this.obs.selectEmpresa.cnpj)})`
            : "Selecione uma empresa";

        let empresaSoText = this.obs.selectEmpresaSo.cnpj != ""
            ? `${this.obs.selectEmpresaSo.razao_social.substring(0, 38)}... (${formatCnpj(this.obs.selectEmpresaSo.cnpj)})`
            : "Selecione uma empresa";

        const buttonFormaterError = (cell, row) => {
            return (
                <>
                    <MDBBtn
                        disabled={!row.error || row.erros?.length == 0}
                        color="default"
                        rounded
                        size="sm"
                        onClick={(e) => handleViewDetalhes(row)}
                    >
                        <img src="/images/view.png" width="18px" />
                    </MDBBtn>
                </>
            );
        }

        const buttonFormaterDelete = (cell, row) => {
            return (
                <>
                    <Popover popoverClassName={Classes.POPOVER_CONTENT_SIZING}>
                        <MDBBtn color="default" rounded size="sm" disabled={!row.id || row.finalizado}>
                            <img src="/images/bin.png" width={25} />
                        </MDBBtn>
                        <div>
                            <H5>Confirmar Cancelamento?</H5>
                            <p style={{ fontSize: 12 }}>Tem certeza de que deseja cancelar esse item?</p>

                            <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 15 }}>
                                <Button className={Classes.POPOVER_DISMISS} style={{ marginRight: 10 }}>
                                    Fechar
                                </Button>
                                <Button intent="danger" className={Classes.POPOVER_DISMISS} onClick={(e) => this.handleDeleteDec(row)}>
                                    Cancelar
                                </Button>
                            </div>
                        </div>
                    </Popover>

                </>
            );
        }

        const handleViewDetalhes = async (row: any) => {
            this.obs.erros = row.erros || [row.error]

            if (this.obs.erros.length > 0) {
                this.obs.view_erros = true
            } else {
                toast.warn("Nenhum erro encontrado!", {});
                return
            }
        };

        return (
            <>
                <Tabs
                    id="tabs"
                    className={"tabsCalculos"}
                    selectedTabId={DecSefaStore.obs.selectedTab}
                    onChange={(tabId) => this.handleChangeTab(String(tabId))}
                >
                    <Tab
                        id="tarefas"
                        title="Solicitações"
                        panel={<>
                            <MDBRow>
                                <MDBCol md="4">
                                    <FormGroup className="empresaSelect" label="Empresa">
                                        <EmpresaSelect
                                            items={EmpresaStore.sortedEmpresas.filter(x => x["filial"] == false)}
                                            itemRenderer={renderEmpresa}
                                            itemPredicate={filterEmpresa}
                                            onItemSelect={(e: IEmpresa) => this.handleBuscaTarefas(e)}
                                            inputProps={{ placeholder: "Filtrar uma empresa" }}
                                        >
                                            <Button
                                                text={empresaText}
                                                rightIcon="double-caret-vertical"
                                                alignText={Alignment.LEFT} />
                                        </EmpresaSelect>
                                    </FormGroup>
                                </MDBCol>
                                <MDBCol md="2">
                                    <MDBBtn
                                        className="btnDefault btnBuscarNfe mt25"
                                        onClick={() => this.handleAtualizaTarefasPaged()}
                                    >
                                        Atualizar
                                    </MDBBtn>
                                </MDBCol>
                            </MDBRow>

                            {/* <MDBRow>
                                <MDBCol
                                    xl="12"
                                    lg="12"
                                    md="12"
                                    sm="12"
                                    xs="12"
                                    className="btns-Drop"
                                >
                                    <MDBBtn
                                        className="btnDefault btnBuscarNfe"
                                        onClick={(e) => DecSefaStore.obs.programar_dec = true}
                                        style={{ marginRight: 20, float: "right" }}
                                    >
                                        Criar Solicitação
                                    </MDBBtn>
                                </MDBCol>
                            </MDBRow> */}

                            <div>
                                <BootstrapTable className="TableDefault" ref="table" data={sortBy(DecSefaStore.obs.tasks_decsefa, "inserted_at").reverse()}>
                                    <TableHeaderColumn dataField="_id" isKey={true} hidden width="1%">#</TableHeaderColumn>
                                    <TableHeaderColumn dataFormat={dateFormatter} dataField="inserted_at" width="20%">Data Solicitação</TableHeaderColumn>
                                    <TableHeaderColumn dataFormat={dateFormatter} dataField="_modifiedTS" width="20%">Ultima Atualização</TableHeaderColumn>
                                    <TableHeaderColumn dataFormat={tipoFormatter} dataField="tipo" width="15%">Tipo</TableHeaderColumn>
                                    <TableHeaderColumn dataFormat={statusFormatter} width="30%">Status</TableHeaderColumn>
                                    <TableHeaderColumn dataFormat={this.formatterOrigem} width="15%">Origem</TableHeaderColumn>
                                    <TableHeaderColumn dataFormat={msgFormatter} dataField="mensagem" width="40%">Mensagem</TableHeaderColumn>
                                    <TableHeaderColumn dataFormat={buttonFormaterError} width="10%">Erros</TableHeaderColumn>
                                    {!AppStore.obs1.usuario.conta.dec_sefa_new && <TableHeaderColumn dataFormat={buttonFormaterDelete} width="10%">Cancelar</TableHeaderColumn>}
                                </BootstrapTable>
                            </div>

                            <div style={{ marginTop: 5, float: "right", marginBottom: 120 }}>
                                <Pager
                                    currentPage={this.obs.tasks_page}
                                    totalCount={DecSefaStore.obs.tasks_length}
                                    pageSize={15}
                                    onPageChange={page => this.handleBuscaTarefasPaged(page)} />
                            </div>
                        </>} />

                    <Tab
                        id="mensagens"
                        title="Mensagens"
                        panel={<MensagensDecPage />} />
                </Tabs>

                <Dialog
                    isOpen={DecSefaStore.obs.open_empresas_mensagens}
                    onClose={() => DecSefaStore.obs.open_empresas_mensagens = false}
                    title={"Contribuintes com mensagens"}
                    className="modal-mensagens"
                >
                    <div className={Classes.DIALOG_BODY}>
                        <div className="table-mensagens">
                            <div className="dropdownNotification text-mensagens">
                                {DecSefaStore.obs.mensagens_pendentes?.map((el: any) => {
                                    let empresa = EmpresaStore.getByCnpj(el.cnpj)
                                    if (empresa) {
                                        return (
                                            <>
                                                <p>
                                                    Contribuinte
                                                    {" "}<b>{empresa.razao_social} - ({formatCnpj(el.cnpj)})</b>{" "}
                                                    {el.count == 0 && "não possui mensagens."}
                                                    {el.count == 1 && "possui uma mensagem."}
                                                    {el.count >= 2 && "possui mensagens."}
                                                </p>
                                            </>
                                        )
                                    }
                                })}
                            </div>
                        </div>
                    </div>
                    <div className={Classes.DIALOG_FOOTER}>
                        <div className={Classes.DIALOG_FOOTER_ACTIONS}>
                            <Button text="Fechar" intent="primary" onClick={() => DecSefaStore.obs.open_empresas_mensagens = false} />
                        </div>
                    </div>
                </Dialog>

                <Dialog
                    isOpen={DecSefaStore.obs.programar_dec}
                    onClose={() => DecSefaStore.obs.programar_dec = false}
                    className="AlertUser"
                >
                    <h2 className="titleSEFAZ">Solicitar DEC</h2>

                    <MDBRow>
                        <MDBCol md="12">
                            <FormGroup className="empresaSelect" label="Empresa">
                                <EmpresaSelect
                                    items={EmpresaStore.sortedEmpresas}
                                    itemRenderer={renderEmpresa}
                                    itemPredicate={filterEmpresa}
                                    onItemSelect={(e: IEmpresa) => this.obs.selectEmpresaSo = e}
                                    inputProps={{ placeholder: "Filtrar uma empresa" }}
                                >
                                    <Button
                                        text={empresaSoText}
                                        rightIcon="double-caret-vertical"
                                        alignText={Alignment.LEFT}
                                    />
                                </EmpresaSelect>
                            </FormGroup>
                        </MDBCol>
                    </MDBRow>

                    <div className={Classes.DIALOG_FOOTER_ACTIONS}>
                        <Button text="Cancelar" onClick={() => this.handleClose()} />
                        <Button text="Solicitar" intent="primary" onClick={() => this.handleCreateTask()} />
                    </div>
                </Dialog>

                <Alert
                    confirmButtonText="Fechar"
                    isOpen={this.obs.view_erros}
                    onConfirm={() => this.onCloseErros()}
                    onClose={() => this.onCloseErros()}
                    canOutsideClickCancel={true}
                    className="AlertUser"
                    intent="primary"
                >
                    <h3 className="titleProccess titleCnae">Logs Erros</h3>
                    <br />
                    {this.obs.erros.map(values => {
                        return (<p>{values}</p>)
                    })}
                </Alert>

                <LoadingModal open={DecSefaStore.obs.loading_tasks} onClose={() => DecSefaStore.obs.loading_tasks = false} title={"Buscando solicitações"} />

            </>
        )
    }
}

